import { Typography } from "@mui/material";
import { ChatPreference } from "../../assets/interfaces/interfaces";
import { capitalizeFirstChar } from "../../helpers";

const UserResponseCustomization = ({ chatPreferences }: { chatPreferences: ChatPreference }) => {
  return (
    <div className="max-w-[308px] bg-white dark:bg-background/paper-elevation-8">
      <Typography variant="body2/regular-400" className="dark:text-white">Response Customization</Typography>

      <div className="grid grid-cols-[127px_auto] gap-x-1 pb-1 pt-2">
        <Typography variant="caption/regular-400" className="text-mui-black-60 dark:text-mui-white-70 text-left">Information Richness</Typography>
        <Typography variant="caption/regular-400" className="text-mui-black-87 dark:text-white text-left">{capitalizeFirstChar(chatPreferences?.information_richness)}</Typography>
      </div>

      <div className="grid grid-cols-[127px_auto] gap-x-1 pb-1">
        <Typography variant="caption/regular-400" className="text-mui-black-60 dark:text-mui-white-70 text-left">
          Level of Expertise
        </Typography>
        <Typography variant="caption/regular-400" className="text-mui-black-87 dark:text-white text-left">{capitalizeFirstChar(chatPreferences?.expertise_level)}</Typography>
      </div>

      <div className="grid grid-cols-[127px_auto] gap-x-1 pb-1">
        <Typography variant="caption/regular-400" className="text-mui-black-60 dark:text-mui-white-70 text-left">Market Cap</Typography>
        <Typography variant="caption/regular-400" className="text-mui-black-87 dark:text-white text-left">{capitalizeFirstChar(chatPreferences?.market_cap)}</Typography>
      </div>

      <div className="grid grid-cols-[127px_auto] gap-x-1 pb-1 items-start">
        <Typography variant="caption/regular-400" className="dark:text-mui-white-70 text-mui-black-60 text-left">Included Sector</Typography>
        <Typography variant="caption/regular-400" className="text-mui-black-87 dark:text-white text-left">
          {chatPreferences?.include_sectors
            .map(sector => capitalizeFirstChar(sector.replace(/_/g, " ")))
            .join(", ")}
        </Typography>
      </div>

      <div className="grid grid-cols-[127px_auto] gap-x-1 items-start">
        <Typography variant="caption/regular-400" className="dark:text-mui-white-70 text-mui-black-60 text-left">Excluded Sector</Typography>
        <Typography variant="caption/regular-400" className="text-mui-black-87 dark:text-white text-left">
          {chatPreferences?.exclude_sectors
            .map(sector => capitalizeFirstChar(sector.replace(/_/g, " ")))
            .join(", ")}
        </Typography>
      </div>
    </div>

  );
};
export default UserResponseCustomization;
